import React from "react";

function TruckXl2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74.591"
      height="30.632"
      viewBox="0 0 74.591 30.632"
    >
      <g transform="translate(.325 .325)">
        <path
          d="M823.6 53.614a4.686 4.686 0 01-8.806-1.1"
          className="cls-1"
          transform="translate(-804.674 -26.273)"
        ></path>
        <path
          d="M858.8 57.567h-1.87a4.682 4.682 0 01-4.107-2.43"
          className="cls-1"
          transform="translate(-823.7 -27.585)"
        ></path>
        <path
          d="M838.129 56.255h-1.874a4.686 4.686 0 01-4.59-3.741"
          className="cls-1"
          transform="translate(-813.116 -26.273)"
        ></path>
        <path
          d="M903.784 53.614a4.686 4.686 0 01-8.806-1.1"
          className="cls-1"
          transform="translate(-844.792 -26.273)"
        ></path>
        <path
          d="M918.318 56.255h-1.874a4.686 4.686 0 01-4.589-3.741"
          className="cls-1"
          transform="translate(-853.235 -26.273)"
        ></path>
        <path
          d="M922.9 26.238v-6.764a.936.936 0 00-.71-.908l-6.783-1.7-1.573-7.862A1.874 1.874 0 00912 7.5h-7.833"
          className="cls-1"
          transform="translate(-849.387 -3.752)"
        ></path>
        <path
          d="M900.413 7.5h1.874v22.486"
          className="cls-1"
          transform="translate(-847.511 -3.752)"
        ></path>
        <path
          d="M0 0h14.286"
          className="cls-1"
          transform="translate(40.49 22.486)"
        ></path>
        <path
          d="M14.94 0H0"
          className="cls-1"
          transform="translate(39.836 26.233)"
        ></path>
        <path
          d="M0 0h3.615"
          className="cls-1"
          transform="translate(16.865 22.486)"
        ></path>
        <path
          d="M934.721 45h3.231a.284.284 0 01.284.284v2.386c0 .781-.424 1.118-1.2 1.118l-3.072-.028"
          className="cls-1"
          transform="translate(-864.295 -22.513)"
        ></path>
        <path
          d="M795.716 48.747h14.991a.936.936 0 00.7-.937v-1.874a.937.937 0 00-.937-.937h-14.99a.937.937 0 00-.937.937v1.874c.002.517.422.937 1.173.937z"
          className="cls-1"
          transform="translate(-794.545 -22.513)"
        ></path>
        <path
          d="M912.924 11.25h-4.774a.234.234 0 00-.234.234v7.027a.234.234 0 00.234.234h6.741a.233.233 0 00.234-.234.268.268 0 000-.045l-1.278-6.461a.938.938 0 00-.923-.755z"
          className="cls-1"
          transform="translate(-851.265 -5.628)"
        ></path>
        <path
          d="M830.027 45h-5.5"
          className="cls-2"
          transform="translate(-809.547 -22.513)"
        ></path>
        <path
          d="M824.531 0h36.5a1.42 1.42 0 011.42 1.42v21.066h-12.414"
          className="cls-1"
          transform="translate(-809.547)"
        ></path>
        <path
          d="M798.295 22.486V1.42a1.42 1.42 0 011.42-1.42h11.7v22.486"
          className="cls-1"
          transform="translate(-796.421)"
        ></path>
        <path
          d="M920.479 45.92a5.623 5.623 0 10-11.084 0h-5.232"
          className="cls-1"
          transform="translate(-849.387 -19.686)"
        ></path>
        <circle
          cx="4.685"
          cy="4.685"
          r="4.685"
          className="cls-1"
          transform="translate(60.397 20.612)"
        ></circle>
        <circle
          cx="2.811"
          cy="2.811"
          r="2.811"
          className="cls-3"
          transform="translate(62.271 22.486)"
        ></circle>
        <path
          d="M851.837 45.92a5.623 5.623 0 00-10.553-3.5l-.034.068a5.623 5.623 0 00-10.586 1.537 10.53 10.53 0 000 1.9h-3.776"
          className="cls-1"
          transform="translate(-810.726 -19.686)"
        ></path>
        <circle
          cx="4.685"
          cy="4.685"
          r="4.685"
          className="cls-1"
          transform="translate(30.416 20.612)"
        ></circle>
        <circle
          cx="4.685"
          cy="4.685"
          r="4.685"
          className="cls-1"
          transform="translate(20.327 20.612)"
        ></circle>
        <circle
          cx="2.811"
          cy="2.811"
          r="2.811"
          className="cls-3"
          transform="translate(32.289 22.486)"
        ></circle>
        <circle
          cx="2.811"
          cy="2.811"
          r="2.811"
          className="cls-3"
          transform="translate(22.201 22.486)"
        ></circle>
        <path
          d="M893.8 3.75a.937.937 0 01.937.937v16.865a.937.937 0 01-.937.937.937.937 0 01-.937-.937V4.687a.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-843.732 -1.876)"
        ></path>
        <path
          d="M886.015 3.75a.937.937 0 01.937.937v16.865a.937.937 0 01-.937.937.937.937 0 01-.937-.937V4.687a.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-839.839 -1.876)"
        ></path>
        <path
          d="M877.528 3.75a.937.937 0 01.937.937v16.865a.937.937 0 01-.937.937.937.937 0 01-.937-.937V4.687a.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-835.593 -1.876)"
        ></path>
        <path
          d="M869.748 3.75a.937.937 0 01.937.937v14.991a.937.937 0 01-.937.937.937.937 0 01-.937-.937V4.687a.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-831.701 -1.876)"
        ></path>
        <path
          d="M853.48 3.75a.937.937 0 01.937.937v14.991a.937.937 0 01-.937.937.937.937 0 01-.937-.937V4.687a.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-823.562 -1.876)"
        ></path>
        <path
          d="M861.967 3.75a.937.937 0 01.937.937v14.991a.937.937 0 01-.937.937.937.937 0 01-.937-.937V4.687a.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-827.808 -1.876)"
        ></path>
        <path
          d="M845.7 3.75a.937.937 0 01.937.937v14.991a.937.937 0 01-.937.937.937.937 0 01-.937-.937V4.687a.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-819.669 -1.876)"
        ></path>
        <path
          d="M837.212 3.75a.937.937 0 01.937.937v14.991a.937.937 0 01-.937.937.937.937 0 01-.937-.937V4.687a.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-815.423 -1.876)"
        ></path>
        <path
          d="M829.432 3.75a.937.937 0 01.937.937v16.758a.937.937 0 01-.937.937.937.937 0 01-.937-.937V4.687a.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-811.53 -1.876)"
        ></path>
        <rect
          width="3.045"
          height="2.811"
          className="cls-1"
          rx="1.405"
          transform="translate(.702 22.954)"
        ></rect>
        <rect
          width="3.045"
          height="2.811"
          className="cls-1"
          rx="1.405"
          transform="translate(13.117 22.954)"
        ></rect>
        <path
          d="M907.913 30h2.342a.7.7 0 01-.7.7h-.937a.7.7 0 01-.7-.7z"
          className="cls-4"
          transform="translate(-851.264 -15.009)"
        ></path>
        <path
          d="M907.913 30h2.342a.468.468 0 01-.468.468h-1.406a.468.468 0 01-.468-.468z"
          className="cls-2"
          transform="translate(-851.264 -15.009)"
        ></path>
        <path
          d="M806.731 33.75h3.748a.937.937 0 01.937.937.937.937 0 01-.937.937h-3.748a.937.937 0 01-.937-.937.937.937 0 01.937-.937z"
          className="cls-4"
          transform="translate(-800.173 -16.885)"
        ></path>
      </g>
    </svg>
  );
}

export default TruckXl2;
